import React from 'react';
import Text from '../Text';
// import Text from '../Text';
import styles from './styles.module.scss';

const Button = ({ onClick, children, className = '', tabIndex }) => {
  return (
    <div
      tabIndex={tabIndex}
      onClick={onClick}
      // onKeyDown={onKeyDown}
      className={`${styles.container}${` `}${className}`}
    >
      <div className={styles.wrapper}>
        <Text className={styles.text}>{children}</Text>
      </div>
    </div>
  );
};

export default Button;
